export default {
  previousVersion: "Previous Version",
  nextVersion: "Next Version",
  selectVersion: "Select Version",
  download: "Download document",
  deleteDocument: "Delete Document"
};
